<template>
  <div class="studio-container">
    <h2>Ad Design Studio</h2>
    
    <!-- Toolbar -->
    <div class="toolbar">
      <label>Choose Website or App:</label>
      <select v-model="selectedSize" @change="changeCanvasSize">
        <option value="quizstar">QuizStar</option>
        <option value="myyaak">myyaak</option>
        <option value="sportstrade">Sportstrade</option>
        <option value="myvoco">Myvoco</option>
        <option value="damnntips">Damnntips</option>
        <option value="droad">Droad</option>
      </select>
      <button @click="uploadImage">Upload Image</button>
      <button @click="deleteSelected">🗑 Delete</button>
      <button @click="exportImage">Export Banner</button>
    </div>
    <div class="toolbar">
      <label>Background Color:</label>
      <input type="color" v-model="bgColor" @input="changeBackground" />

      <button @click="addText">Add Text</button>
      <button @click="toggleBold"><b>B</b></button>
      <button @click="toggleItalic"><i>I</i></button>
      <button @click="toggleUnderline"><u>U</u></button>
      
      <label>Font:</label>
      <select v-model="selectedFont" @change="changeFont">
        <option value="Arial">Arial</option>
        <option value="Times New Roman">Times New Roman</option>
        <option value="Courier New">Courier New</option>
        <option value="Georgia">Georgia</option>
      </select>
      
      <label>Font Size:</label>
      <input type="number" v-model="fontSize" @input="changeFontSize" min="10" max="100" />
      
      <label>Text Color:</label>
      <input type="color" v-model="textColor" @input="changeTextColor" />
    </div>
    
   
    
    <div class="toolbar">
      <button @click="moveForward">Move Forward</button>
      <button @click="moveBackward">Move Backward</button>
      <label>Set Background Image:</label>
      <input type="file" @change="setBackgroundImage" accept="image/*" />
    </div>
    
    <div class="toolbar">
      <button @click="addRectangle">Add Rectangle</button>
      <button @click="addCircle">Add Circle</button>
      <button @click="addLine">Add Line</button>
      
      <label>Shape Color:</label>
      <input type="color" v-model="shapeColor" @input="changeShapeColor" />
      
      <label>Border Color:</label>
      <input type="color" v-model="borderColor" @input="changeBorderColor" />
      
      <label>Stroke Width:</label>
      <input type="number" v-model="strokeWidth" @input="changeStrokeWidth" min="1" max="10" />
    </div>
    <input type="file" ref="imageInput" @change="handleImageUpload" accept="image/*" hidden />
    <!-- Fabric.js Canvas -->
    <div class="canvas-container"><canvas ref="bannerCanvas" ></canvas></div>
  </div>
</template>
  <script>
  const fabric = require("fabric").fabric;
  import FontFaceObserver from "fontfaceobserver";
export default {
  data() {
    return {
      canvas: null,
      bgColor: "#ffffff", // Default background color
      fontSize: 30,
    selectedFont: "Arial",
      textColor: "#000000", // Default text color
      activeText: null, // To store the selected text object
      shapeColor: "#ff0000", // Default color (Red)
      borderColor: "#000000", // Default black
      strokeWidth: 2, // Default stroke width
      selectedSize: "quizstar",
      sizes: {
        quizstar: { width: 300, height: 250 },
        myyaak: { width: 600, height: 350 },
        sportstrade: { width: 728, height: 90 },
        myvoco: { width: 728, height: 90 },
        damnntips: { width: 750, height: 90 },
        droad: { width: 300, height: 250 },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      const size = this.sizes[this.selectedSize];
      this.canvas = new fabric.Canvas(this.$refs.bannerCanvas, {
        width: size.width,
        height: size.height,
      });
      document.addEventListener("keydown", this.handleKeyPress);
      this.canvas.setBackgroundColor(this.bgColor, this.canvas.renderAll.bind(this.canvas));

      this.canvas.on("selection:created", (event) => {
        if (event.target && event.target.type === "text") {
          this.activeText = event.target;
          this.fontSize = this.activeText.fontSize;
          this.textColor = this.activeText.fill;
        }
      });

      this.canvas.on("selection:updated", (event) => {
        if (event.target && event.target.type === "text") {
          this.activeText = event.target;
          this.fontSize = this.activeText.fontSize;
          this.textColor = this.activeText.fill;
        }
      });
    });
  },
  beforeDestroy() {
  document.removeEventListener("keydown", this.handleKeyPress); // Cleanup
},
  methods: {
    changeCanvasSize() {
      console.log(this.selectedSize);
      const size = this.sizes[this.selectedSize];
      
      this.canvas.setWidth(size.width);
      this.canvas.setHeight(size.height);
      this.canvas.renderAll();
    },
    deleteSelected() {
    const obj = this.canvas.getActiveObject();
    if (obj) {
      this.canvas.remove(obj);
      this.canvas.renderAll();
    }
  },

  handleKeyPress(event) {
    if (event.key === "Delete" || event.key === "Backspace") {
      this.deleteSelected();
    }
  },
    enableObjectControls(obj) {
    if (!obj) return;
    obj.set({
      selectable: true,
      hasControls: true, // Enables resize & rotate controls
      lockUniScaling: false, // Allow free resizing
    });
    this.canvas.renderAll();
  },
  addText() {
    if (!this.canvas) return console.error("Canvas not initialized.");

    const text = new fabric.IText("Edit Me!", {
      left: 100,
      top: 100,
      fontSize: 30,
      fill: this.textColor,
      fontWeight: "normal",
      fontStyle: "normal",
      underline: false,
    });

    this.canvas.add(text);
    this.canvas.setActiveObject(text);
    this.enableObjectControls(text);
  },
  toggleBold() {
  const obj = this.canvas.getActiveObject();
  if (!obj || obj.type !== "i-text") return;

  const currentFont = obj.fontFamily; // Preserve font family
  obj.set("fontWeight", obj.fontWeight === "bold" ? "normal" : "bold");
  obj.set("fontFamily", currentFont); // Restore font family

  this.canvas.renderAll();
},

toggleItalic() {
  const obj = this.canvas.getActiveObject();
  if (!obj || obj.type !== "i-text") return;

  const currentFont = obj.fontFamily; // Preserve font family
  obj.set("fontStyle", obj.fontStyle === "italic" ? "normal" : "italic");
  obj.set("fontFamily", currentFont); // Restore font family

  this.canvas.renderAll();
},

toggleUnderline() {
  const obj = this.canvas.getActiveObject();
  if (!obj || obj.type !== "i-text") return;

  const currentFont = obj.fontFamily; // Preserve font family
  obj.set("underline", !obj.underline);
  obj.set("fontFamily", currentFont); // Restore font family

  this.canvas.renderAll();
},
  changeFont() {
  const obj = this.canvas.getActiveObject();

  if (!obj || obj.type !== "i-text") {
    console.warn("No text object selected or not a text element.");
    return;
  }

  console.log("Changing Font Family:", this.selectedFont, "for Object:", obj);

  // Load the font before applying
  const font = new FontFaceObserver(this.selectedFont);
  font.load(null, 10000) // Wait 10 seconds instead of 3
  .then(() => {
    obj.set("fontFamily", this.selectedFont);
    this.canvas.renderAll();
    console.log(" Font Applied Successfully:", this.selectedFont);
  })
  .catch((error) => {
    console.error(` Failed to load font: ${this.selectedFont}`, error);
  });
},
changeFontSize() {
  const obj = this.canvas.getActiveObject();

  if (!obj || obj.type !== "i-text") {
    console.warn(" No text object selected or not a text element.");
    return;
  }

  console.log("Changing Font Size:", this.fontSize, "for Object:", obj);

  obj.set({
    fontSize: parseInt(this.fontSize, 10),
  });

  obj.setCoords();
  this.canvas.renderAll();
},
 
    changeTextColor() {
    const obj = this.canvas.getActiveObject();
    if (!obj || obj.type !== "i-text") return;

    obj.set("fill", this.textColor);
    this.canvas.renderAll();
  },
  moveForward() {
    const obj = this.canvas.getActiveObject();
    if (!obj) return console.warn("No object selected.");
    
    obj.bringForward();
    this.canvas.renderAll();
    console.log("Moved Forward:", obj);
  },

  
  moveBackward() {
    const obj = this.canvas.getActiveObject();
    if (!obj) return console.warn("No object selected.");

    obj.sendBackwards();
    this.canvas.renderAll();
    console.log("Moved Backward:", obj);
  },
  setBackgroundImage(event) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      fabric.Image.fromURL(e.target.result, (img) => {
        this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas), {
          scaleX: this.canvas.width / img.width,
          scaleY: this.canvas.height / img.height,
        });
        console.log("Background Image Set");
      });
    };
    reader.readAsDataURL(file);
  },
  addRectangle() {
    const rect = new fabric.Rect({
      left: 100,
      top: 100,
      width: 100,
      height: 50,
      fill: this.shapeColor,
      selectable: true,
      hasControls: true, // Enables resizing & rotation
    });

    this.canvas.add(rect);
    this.canvas.setActiveObject(rect);
    this.canvas.renderAll();
  },

  addCircle() {
    const circle = new fabric.Circle({
      left: 150,
      top: 150,
      radius: 50,
      fill: this.shapeColor,
      selectable: true,
      hasControls: true, // Enables resizing & rotation
    });

    this.canvas.add(circle);
    this.canvas.setActiveObject(circle);
    this.canvas.renderAll();
  },

  addLine() {
    const line = new fabric.Line([50, 200, 200, 200], {
      stroke: this.shapeColor,
      strokeWidth: 5,
      selectable: true,
      hasControls: true, // Enables resizing & rotation
    });

    this.canvas.add(line);
    this.canvas.setActiveObject(line);
    this.canvas.renderAll();
  },
  changeShapeColor() {
    const activeObject = this.canvas.getActiveObject();

    if (!activeObject) {
      console.warn("No shape selected to change color.");
      return;
    }

    // Apply color change only if the selected object is a shape
    if (activeObject.type === "rect" || activeObject.type === "circle" || activeObject.type === "line") {
      if (activeObject.type === "line") {
        activeObject.set("stroke", this.shapeColor);
      } else {
        activeObject.set("fill", this.shapeColor);
      }

      this.canvas.renderAll();
      console.log(`Shape color changed to: ${this.shapeColor}`);
    } else {
      console.warn("Selected object is not a shape.");
    }
  },
    changeBackground() {
      if (!this.canvas) return console.error("Canvas not initialized.");

      this.canvas.setBackgroundColor(this.bgColor, this.canvas.renderAll.bind(this.canvas));
    },
    changeBorderColor() {
    const obj = this.canvas.getActiveObject();
    if (obj && obj.type !== "text") { 
      obj.set("stroke", this.borderColor); // Set border color
      this.canvas.renderAll();
      console.log("Border Color Changed:", this.borderColor);
    } else {
      console.warn("No shape selected.");
    }
  },

  changeStrokeWidth() {
    const obj = this.canvas.getActiveObject();
    if (obj && obj.type !== "text") {
      obj.set({
        strokeWidth: this.strokeWidth,
        strokeUniform: true, //Ensures stroke stays within bounds
      });
      this.canvas.renderAll();
      console.log("Stroke Width Changed:", this.strokeWidth);
    } else {
      console.warn("No shape selected.");
    }
  },
    uploadImage() {
      this.$refs.imageInput.click();
    },

    handleImageUpload(event) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
        fabric.Image.fromURL(e.target.result, (img) => {
            // Get current canvas dimensions
            const canvasWidth = this.canvas.width;
            const canvasHeight = this.canvas.height;

            // Scale image to fit within canvas dimensions
            const scaleFactor = Math.min(canvasWidth / img.width, canvasHeight / img.height);

            img.set({
                left: canvasWidth / 2,
                top: canvasHeight / 2,
                originX: "center",
                originY: "center",
                scaleX: scaleFactor,
                scaleY: scaleFactor,
            });

            this.canvas.add(img);
            this.canvas.setActiveObject(img);
            this.enableObjectControls(img);
        });
    };
    reader.readAsDataURL(file);
},

    exportImage() {
      if (!this.canvas) return console.error("Canvas not initialized.");
      const dataURL = this.canvas.toDataURL({
        format: "png",
        quality: 1.0,
      });

      const link = document.createElement("a");
      link.href = dataURL;
      link.download = "banner.png";
      link.click();
    },
  },
};
</script>
<style scoped>
.studio-container {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
}
.canvas-container{display: flex; justify-content: center;}
.toolbar {
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background: #f4f4f4;
  border-radius: 8px;
  margin-bottom: 10px;
}

button {
  padding: 8px 12px;
  border: none;
  background-color: #3498db;
  color: white;
  cursor: pointer;
  border-radius: 6px;
  font-weight: bold;
}

button:hover {
  background-color: #2980b9;
}

input[type="color"] {
  width: 40px;
  height: 30px;
  border: none;
  cursor: pointer;
}

label {
  font-weight: bold;
}

canvas {
  border: 2px solid #000;
  margin-top: 10px;
  border-radius: 8px;
}
</style>
